import { Route, Routes } from 'react-router-dom';
import { NotFound, ShippingRelationship } from '@pages';
import Protected from '@components/Protected';

function RoutesShippingRelationship() {
  return (
    <Protected>
      <Routes>
        <Route index element={<ShippingRelationship />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesShippingRelationship;
